module.exports = __webpack_public_path__ + "media/images/brands/logo_energie_experten_bleed-35679fb212d280872e1ebd54459a38ab.svg";